import { PendingButton } from "@/components/common/PendingButton/PendingButton"
import { Alert } from "@/components/ui/alert"
import { Skeleton } from "@/components/ui/skeleton"
import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { CircleAlert } from "lucide-react"

/** Placeholder rows while a settings page loads its data. */
export function SettingsSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-4" aria-busy="true">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-10 w-full" />
      ))}
    </div>
  )
}

/** Shown instead of content whose data could not be loaded. */
export function SettingsLoadError({
  onRetry,
  pending = false,
}: {
  onRetry: () => void
  /** The retry is running. */
  pending?: boolean
}) {
  const { translate } = useTranslation()
  return (
    <Alert variant="destructive">
      <CircleAlert className="size-4" />
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Typography as="small">{translate("SETTINGS/LOAD_ERROR")}</Typography>
        <PendingButton
          variant="outline"
          size="sm"
          pending={pending}
          onClick={onRetry}
        >
          {translate("SETTINGS/RETRY")}
        </PendingButton>
      </div>
    </Alert>
  )
}
